import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useSignInWithKakao from './hooks/useSignInWithKakao';

interface Params {
    code: string;
}

declare module '@stackflow/config' {
    interface Register {
        SignInWithKakaoActivity: Params;
    }
}

const SignInWithKakaoActivity: ActivityComponentType<'SignInWithKakaoActivity'> = ({ params }) => {
    const { code } = params;
    useSignInWithKakao(code);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default SignInWithKakaoActivity;
